import { a4Doc } from "./a4doc";
import { esc, n2 } from "./format";

/* Printable GRN, POS receipt and payslip, all on the shared A4 layout. */

export const grnHtml = (g) => a4Doc({
  title: "Goods Received Note", number: g.grn_id, partyLabel: "Supplier",
  party: { name: g.client_name, lines: [g.contact_phone, g.contact_email, g.address] },
  meta: [["Received", String(g.received_date || "").slice(0, 16)], ["Purchase order", g.po_id ? `#${g.po_id}` : ""], ["Received by", g.received_by], ["Status", g.status]],
  columns: [{ label: "#", fmt: (r) => r._i }, { label: "Description", key: "description" }, { label: "Qty received", right: true, fmt: (r) => esc(String(r.quantity_received)) },
    { label: "Unit price", right: true, fmt: (r) => n2(r.unit_price) }, { label: "Amount", right: true, fmt: (r) => n2(r.total) }],
  rows: g.items.map((r, i) => ({ ...r, _i: i + 1 })), totals: [["Total value (TZS)", n2(g.total), true]], notes: g.notes,
  signatures: ["Received by", "Checked by"],
});

export const receiptHtml = (p) => {
  const total = Number(p.payment_amount) || 0, lines = p.items.reduce((s, i) => s + Number(i.total_amount || 0), 0);
  return a4Doc({
    title: "Receipt", number: p.payment_id, partyLabel: "Customer",
    party: { name: p.client_name || "Walk-in", lines: [p.contact_phone, p.address] },
    meta: [["Date", String(p.payment_date || "").slice(0, 16)], ["Paid by", p.payment_method], ["Status", p.status]],
    columns: [{ label: "#", fmt: (r) => r._i }, { label: "Item", key: "product_name" }, { label: "Qty", right: true, fmt: (r) => esc(String(r.quantity_sold)) },
      { label: "Unit price", right: true, fmt: (r) => n2(r.sale_price) }, { label: "Amount", right: true, fmt: (r) => n2(r.total_amount) }],
    rows: p.items.map((r, i) => ({ ...r, _i: i + 1 })),
    totals: [...(Math.abs(lines - total) > 0.01 && p.items.length ? [["Items", n2(lines)], ["Discount", n2(lines - total)]] : []), ["Amount paid (TZS)", n2(total), true]],
    signatures: ["Cashier", "Customer"],
  });
};

export const monthLabel = (m) => (m ? new Date(String(m).slice(0, 10) + "T00:00:00").toLocaleDateString("en-GB", { month: "long", year: "numeric" }) : "–");

export function payslipLines(s) {
  // payroll.deductions already includes PAYE and the employee pension (PayrolManagement.php adds them in), so they are
  // shown as "of which" information, not as extra deductions.
  const earn = [["Basic salary", s.salary], ["Bonus", s.bonus]];
  const ded = [["Deductions", s.deductions], ["Salary advance", s.salary_advance]];
  return { earn, ded, gross: earn.reduce((t, [, v]) => t + (Number(v) || 0), 0) };
}

export const payslipHtml = (s) => {
  const { earn, ded, gross } = payslipLines(s);
  const rows = [...earn.map(([k, v]) => ({ k, e: v, d: null })), ...ded.map(([k, v]) => ({ k, e: null, d: v }))];
  return a4Doc({
    title: "Payslip", number: s.payroll_id, partyLabel: "Employee",
    party: { name: s.client_name, lines: [s.position, s.hire_date ? `Hired ${String(s.hire_date).slice(0, 10)}` : "", `Staff no. ${s.staff_id}`] },
    meta: [["Pay period", monthLabel(s.payment_month)], ["Status", s.payment_status]],
    columns: [{ label: "Item", key: "k" }, { label: "Earnings", right: true, fmt: (r) => (r.e == null ? "" : n2(r.e)) }, { label: "Deductions", right: true, fmt: (r) => (r.d == null ? "" : n2(r.d)) }],
    rows, totals: [["Gross pay", n2(gross)], ["Net pay (TZS)", n2(s.net_salary), true]],
    notes: `Deductions include PAYE ${n2(s.paye_tax)} and employee pension ${n2(s.pension_contribution)}. Employer pension contribution (paid by the employer, not deducted): ${n2(s.employer_pension)}.`,
    signatures: ["Employer", "Employee"],
  });
};
